import { Polyline } from 'react-leaflet';

function VehicleRoutePolyline({ coords }) {
  if (!coords || coords.length === 0) return null;

  return (
    <Polyline positions={coords} color="blue" weight={4} opacity={0.6} />
  );
}

export default VehicleRoutePolyline;